export default __webpack_public_path__ + "static/media/NotoSerifTelugu.2280f1bb.ttf";